import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/print-formats`;

export const printFormatsApi = {
  doctypes: () => axios.get(`${BASE}/meta/doctypes`),
  fields: (doctype) => axios.get(`${BASE}/meta/fields/${doctype}`),
  sample: (doctype) => axios.get(`${BASE}/meta/sample/${doctype}`),
  render: (payload) => axios.post(`${BASE}/render`, payload),
  list: (params = {}) => axios.get(BASE, { params }),
  get: (id) => axios.get(`${BASE}/${id}`),
  create: (payload) => axios.post(BASE, payload),
  update: (id, payload) => axios.put(`${BASE}/${id}`, payload),
  remove: (id) => axios.delete(`${BASE}/${id}`),
};

export default printFormatsApi;
